import React, { useState } from 'react';
import CollapseWrapper from '@hpstellar/core/CollapseWrapper';
import WordCloud from '@hpstellar/core/Wordcloud';
import Link from '@hpstellar/core/Link';
import { AngleDown } from '@hpstellar/core/Icons';

import withPageComponents from '../with-page-components';
import DisclaimerList from '../disclaimer-list';

import './disclaimer-tabs.less'

const getTabs = (wordCloud) => {
    let tabs = [];
    if (wordCloud && wordCloud.length > 0) {
        tabs.push({
            title: 'More Useful Links',
            Component: <WordCloud links={wordCloud} />
        })
    }
    tabs.push({
        title: 'Disclaimer',
        Component: <DisclaimerList />
    });
    return tabs;
}

const disclaimerTabs = ({
    device,
    wordCloud = []
}) => {
    const [tabIndex, setTabIndex] = useState(-1);

    const toggleTab = (index) => {
        if (index === tabIndex) {
            setTabIndex(-1);
        } else {
            setTabIndex(index);
        }
    }

    const tabs = getTabs(wordCloud);
    if (device === 'mobile') {
        return <>
            {
                tabs.map(t => {
                    return (<CollapseWrapper title={t.title}>
                        {t.Component}
                    </CollapseWrapper>)
                })
            }
        </>
    }
    return <div className={`disclaimer-tabs${tabIndex > -1 ? ' expanded' : ''}`}>
        <div className='tabs-title'>
            { tabs.map((t, i) => (
                <Link 
                    variation='primary'
                    color='dark'
                    className={`title-label${i === 0 ? ' first' : ''}`}
                    onClick={() => toggleTab(i)}
                >
                    {t.title}
                    <AngleDown className={`arrow-icon ${i === tabIndex ? ' up' : ''}`} size='small' />
                </Link>
            ))}
        </div>
        { tabIndex > -1 && tabs[tabIndex].Component }
    </div>
}

export default withPageComponents(disclaimerTabs, { device: true })
